<template>
    <div class="page-footer">
        <p>Copyright &copy; 2024.Arcnix All rights reserved.</p>
    </div>
</template>